/* eslint-disable import/no-anonymous-default-export */
import { SET_IS_EDIT_MODE } from '../actionConstants';

export default (state = false, action) => {
  switch (action.type) {
    case SET_IS_EDIT_MODE:
      return action.payload;
    default:
      return state;
  }
};
